// Kiosk (TV) mode: a dashboard shown alone, without the menu and the top bar (doc 06 §2.1).
// The page that enters it sets the flag; the shell hides itself while it is set.
import { create } from 'zustand';

export const useKiosk = create<{ active: boolean; set: (active: boolean) => void }>((set) => ({
  active: false,
  set: (active) => set({ active }),
}));
